/**
 * Status do Pedido de Compra no novo fluxo de aprovação.
 * Os VALORES espelham exatamente o valor textual serializado pela API
 * (PedidoStatusEnum#getStatus no backend, campo `status` de PedidoFluxoStatusDTO).
 * As CHAVES permanecem em inglês; apenas os valores string precisam bater com a API.
 */
export enum FluxoAprovacaoPedidoStatus {
  EM_ELABORACAO = 'Em_Elaboracao',
  AGUARDANDO_APROVACAO_GESTOR = 'Aguardando_Aprovacao_Gestor',
  ALTERADO_PELO_GESTOR = 'Alterado_Pelo_Gestor',
  AGUARDANDO_VALIDACAO_OPERADOR = 'Aguardando_Validacao_Operador',
  APROVADO_PELO_GESTOR = 'Aprovado_Pelo_Gestor',
  APROVADO_PELO_OPERADOR = 'Aprovado_Pelo_Operador',
  APROVADO_PARA_GERACAO = 'Aprovado_Para_Geracao',
  PEDIDO_GERADO = 'Pedido_Gerado',
  AGUARDANDO_AJUSTE = 'Aguardando_Ajuste',
  REPROVADO = 'Reprovado',
}
